import { DialogRef } from '@angular/cdk/dialog';
import { Component, inject, signal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { CustomOptionSelectComponent } from '../../form/custom-option-select/custom-option-select.component';
import { optionSelectsModel } from '../../models/option-select.model';
import { ApiKeyManagementService } from 'src/app/services/api-key-management-service';
import { tap, catchError, EMPTY } from 'rxjs';
import { ModalsService } from 'src/app/services/modals.service';
import { ShowApiKeyModalComponent } from '../show-api-key-modal/show-api-key-modal.component';
import { openLinkInANewTab } from 'src/app/utils/open-in-a-new-tab.utils';
import { ApiScope, scopes } from 'src/app/utils/get-api-scopes.utils';
import { ToastrFactoryService } from 'src/app/services/toastr-factory.service';
import { ModalBaseComponent } from 'src/app/shared/components/modal-base/modal-base.component';
import { AlertMessageComponent } from '../../alert-message/alert-message.component';

@Component({
  selector: 'app-register-api-modal',
  imports: [TranslateModule, CustomOptionSelectComponent, AlertMessageComponent, ModalBaseComponent],
  templateUrl: './register-api-modal.component.html',
})
export class RegisterApiModalComponent {
  protected translate = inject(TranslateService);
  protected toastrFactory = inject(ToastrFactoryService);
  protected dialogRef = inject(DialogRef);
  protected linkSwaggerApi = signal(environment.apiPublic);
  protected options = signal<optionSelectsModel[]>([{ name: this.translate.instant('integrator'), value: 'partner' }]);
  protected apiKeyService = inject(ApiKeyManagementService);
  protected modalsService = inject(ModalsService);
  scopes = signal<ApiScope[]>(scopes);

  generateApiKey() {
    this.apiKeyService
      .generateApiKey()
      .pipe(
        tap(async (response: any) => {
          const apiKey = response.oneTimeVisibleApiKey;
          this.dialogRef.close(true);
          const res = await this.modalsService.openModal(ShowApiKeyModalComponent, { data: apiKey });
        }),
        catchError((error: any) => {
          this.toastrFactory.unknownError(this.translate.instant('unknownError'));
          console.log(error);
          return EMPTY;
        }),
      )
      .subscribe();
  }

  getApiLink() {
    return environment.apiPublic;
  }

  redirectToApiDocs(docId: string) {
    const url = `${environment.apiPublic}#${docId}`;
    openLinkInANewTab(url);
  }
}
